module.exports = __webpack_public_path__ + "static/media/icon-agenda-online.0d20f62a.svg";